import {Component, Input, inject, DestroyRef} from '@angular/core';
import {Router} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {WidgetConfigService} from '@wellfit/wf-plans-widget';
import {EventsManager} from '../../../events/events.manager';
import {SalesService} from '../../../services/sales.service';

@Component({
  selector: 'app-plan-card',
  templateUrl: './plan-card.component.html',
  styleUrls: ['./plan-card.component.scss'],
  standalone: false
})

export class PlanCardComponent {
  @Input() public cardData: any = {};
  @Input() public templateId: string = '';
  @Input() public practiceId: string = '';
  @Input() public planName: string = '';

  private _destroyRef: DestroyRef = inject(DestroyRef);
  private _eventsManager: EventsManager = inject(EventsManager);
  private _salesService: SalesService = inject(SalesService);
  private _router: Router = inject(Router);
  private _widgetConfigService: WidgetConfigService = inject(WidgetConfigService);

  public readonly pageName: string = 'PlanDetails';

  public get displayPrice(): number {
    return this.cardData.fee + this.cardData.adminFee;
  }

  private _setCoverageLevel(level: any) {
    level.planName = this.planName;
    this._eventsManager.setLevelSelected(level);
    this._salesService.selectPlan(level.benefitPlanCoverageLevelId)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe();
  }

  public setPlanDetails(level: any) {
    this._setCoverageLevel(level);
    const d = {practiceId: this.practiceId, templateId: this.templateId, pageName: this.pageName};
    this._eventsManager.setPlanDetails(d);
  }

  public onJoinNow(): void {
    this._widgetConfigService.setOptions({
      ...this._widgetConfigService.getOptions(),
      organizationId: this._eventsManager.orgId,
      practiceId: this._eventsManager.officeInfo?.practiceId,
      themeId: this._eventsManager.themeId
    });
    this._router.navigate(['/purchase']);
  }
}
